import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/history/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/history/')({
  component: Page,
});
